import React, { FC } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import { SummaryLineSkeleton } from 'src/apps/wfa/components/skeletons/summary-line-skeleton/SummaryLineSkeleton';
import { FilterRows } from 'src/common/components/skeletons/FilterRows';
import { TableSkeleton } from 'src/common/components/skeletons/table-skeleton/TableSkeleton';

import './WfaSessionsSkeleton.scss';

interface WfaSessionsSkeletonProps {
	isAnimated?: boolean;
}

export const WfaSessionsSkeleton: FC<WfaSessionsSkeletonProps> = ({ isAnimated = true }) => {
	const animationSpeed = isAnimated ? undefined : 0;
	const filterHeight = '60px';

	return (
		<div className="wfa-sessions-skeleton">
			<div className="skeleton-main-title">
				<EvSkeleton height="28px" width="170px" animationSpeed={animationSpeed} />
			</div>

			<div className="skeleton-filters-section">
				<div className="skeleton-filters-row">
					<FilterRows
						count={1}
						height={filterHeight}
						width="290px"
						animationSpeed={animationSpeed}
						keySet={['search']}
					/>
					<FilterRows
						count={4}
						height={filterHeight}
						width="140px"
						animationSpeed={animationSpeed}
						keySet={Array.from({ length: 4 }, (_, i) => `filter_${i}`)}
					/>
					<FilterRows
						count={2}
						height="40px"
						width="70px"
						animationSpeed={animationSpeed}
						keySet={Array.from({ length: 2 }, (_, i) => `action_${i}`)}
					/>
				</div>
			</div>

			<div className="skeleton-divider" />

			<div className="skeleton-usage-section">
				<div className="skeleton-section-title">
					<EvSkeleton height="23px" width="110px" animationSpeed={animationSpeed} />
				</div>
				<div className="skeleton-summary-subtitle">
					<EvSkeleton height="18px" width="180px" animationSpeed={animationSpeed} />
				</div>
				<SummaryLineSkeleton animationSpeed={animationSpeed} />
			</div>

			<div className="skeleton-table-section">
				<div className="skeleton-section-title">
					<EvSkeleton height="23px" width="150px" animationSpeed={animationSpeed} />
				</div>
				<div className="skeleton-table-section__action_row">
					<EvSkeleton height="24px" width="295px" animationSpeed={animationSpeed} />
					<div className="skeleton-section-table-actions-spacer" />
					<div className="skeleton-table-section__action_row__buttons">
						<EvSkeleton height="40px" width="110px" animationSpeed={animationSpeed} />
						<EvSkeleton height="40px" width="174px" animationSpeed={animationSpeed} />
						<EvSkeleton height="40px" width="134px" animationSpeed={animationSpeed} />
					</div>
				</div>
				<div className="skeleton-table-content">
					<TableSkeleton columns={5} rowCount={7} />
				</div>
			</div>
		</div>
	);
};
